<div class="kanban-card-container">
  @if (datasKanban.image !== null) {
    <div class="img-container">
      @if (datasKanban.image | docServerUrl | async; as src) {
        <img class="iu-image" [src]="src" (error)="datasKanban.image = ''" alt="kanban image" />
      } @else {
        <span class="kanban-card-initials" aria-hidden="true">{{ initials }}</span>
      }
    </div>
  }
  <div class="other-container">
    @for (dataKanban of datasKanban.rows; track dataKanban) {
      @if (dataKanban.dataAlignLeft.length > 0 || dataKanban.dataAlignright.length > 0) {
        <div class="board-card-line">
          @if (dataKanban.dataAlignLeft.length > 0) {
            <h4 class="board-card-line-left">
              @for (dataAlignLeft of dataKanban.dataAlignLeft; track dataAlignLeft; let first = $first) {
                @if (dataAlignLeft.type === 'text') {
                  <div #element [ngClass]="[first ? 'first' : '', 'board-card-line-data']">
                    @if (isMobile) {
                      <span
                        tooltipPosition="top"
                        showDelay="250"
                        tooltipZIndex="8000"
                        [life]="3000"
                        [hideDelay]="250"
                        pTooltip="{{ dataAlignLeft.value }}"
                        >{{ dataAlignLeft.value | textLimit: 80 }}</span
                      >
                    }
                    @if (!isMobile) {
                      <span [attr.title]="dataAlignLeft.value">{{ dataAlignLeft.value }}</span>
                    }
                  </div>
                }
                @if (dataAlignLeft.type === 'image') {
                  @if (dataAlignLeft.value | docServerUrl | async; as srcLeft) {
                    <img class="iu-image" [src]="srcLeft" (error)="dataAlignLeft.value = ''" alt="kanban image" />
                  } @else {
                    <img
                      class="iu-image"
                      [src]="'assets/imageError.webp'"
                      (error)="dataAlignLeft.value = ''"
                      alt="kanban image" />
                  }
                }
              }
            </h4>
          }
          @if (dataKanban.dataAlignright.length > 0) {
            <div class="board-card-line-right">
              @for (dataAlignright of dataKanban.dataAlignright; track dataAlignright; let first = $first) {
                @if (dataAlignright.type === 'text') {
                  <div #element [ngClass]="[first ? 'first' : '', 'board-card-line-data']">
                    @if (isMobile) {
                      <span
                        tooltipZIndex="8000"
                        tooltipPosition="top"
                        showDelay="250"
                        [life]="3000"
                        [hideDelay]="250"
                        pTooltip="{{ dataAlignright.value }}"
                        >{{ dataAlignright.value | textLimit: 80 }}</span
                      >
                    }
                    @if (!isMobile) {
                      <span [attr.title]="dataAlignright.value">{{ dataAlignright.value }}</span>
                    }
                  </div>
                }
                @if (dataAlignright.value | docServerUrl | async; as srcRight) {
                  @if (dataAlignright.type === 'image') {
                    <img class="iu-image" [src]="srcRight" (error)="dataAlignright.value = ''" alt="kanban image" />
                  }
                } @else {
                  @if (dataAlignright.type === 'image') {
                    <img
                      class="iu-image"
                      [src]="'assets/imageError.webp'"
                      (error)="dataAlignright.value = ''"
                      alt="kanban image" />
                  }
                }
              }
            </div>
          }
        </div>
      }
    }
  </div>
</div>
